/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum Cijferkolomtype {
    TOETS = "Toets",
    ADVIES = "Advies",
    LAATSTE_PERIODEGEMIDDELDE = "Laatste periodegemiddelde",
    LAATSTE_GEMIDDELDE = "Laatste gemiddelde",
    LAATSTE_RAPPORTCIJFER = "Laatste rapportcijfer",
    PERIODEGEMIDDELDE = "Periodegemiddelde",
    GEMIDDELDE = "Gemiddelde",
    RAPPORTCIJFER = "Rapportcijfer",
    SE_CIJFER = "SE-cijfer",
    CE_CIJFER = "CE-cijfer",
    EINDCIJFER = "Eindcijfer"
}
